import styled from 'styled-components';

export const StyledTabs = styled.div`
	display: flex;
	flex-direction: column;
	margin: 8px auto;
	width: 100%;
`;
export const StyledTabContainer = styled.div``;
